import { Stack, Typography } from "@mui/material";
import { CoreButton, coreToast } from "@verity/components/core";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import apiClient from "../../../../../../helpers/api-client";
import i18n from "../../../../../../i18n";
import { successImage } from "./assets";
import styles from "./CompletePage.module.css";

type LocationState = {
	id: string;
	quizId: string;
};

export default function CompletePage() {
	const navigate = useNavigate();
	const { sessionId } = useParams();
	const location = useLocation() as { state: LocationState };
	const { id, quizId } = location.state || {};

	const [endLoading, setEndLoading] = useState(false);

	async function handleEndSession() {
		setEndLoading(true);
		try {
			const success = await apiClient.liveClient.endLiveSession(sessionId!);
			if (success) {
				coreToast.success(i18n.t("candidate.instructorInterviewPage.completed.toast.success"));
				navigate("/interviews");
			} else {
				coreToast.error(i18n.t("candidate.instructorInterviewPage.completed.toast.fail"));
			}
		} catch (error) {
			coreToast.error(i18n.t("candidate.instructorInterviewPage.completed.toast.fail"));
		} finally {
			setEndLoading(false);
		}
	}

	return (
		<div className={styles.pageWrapper}>
			<img src={successImage} alt="" />
			<Typography className={styles.title}>{i18n.t("candidate.instructorInterviewPage.completed.title")}</Typography>
			<Typography className={styles.description}>
				{i18n.t("candidate.instructorInterviewPage.completed.description")}
			</Typography>
			<Stack direction="row" gap="10px">
				{id && quizId && (
					<CoreButton color="secondary" onClick={() => navigate(`/interviews/${id}?quizId=${quizId}`)}>
						{i18n.t("candidate.instructorInterviewPage.completed.buttons.resume")}
					</CoreButton>
				)}
				<CoreButton onClick={handleEndSession} loading={endLoading}>
					{i18n.t("candidate.instructorInterviewPage.completed.buttons.complete")}
				</CoreButton>
			</Stack>
		</div>
	);
}
